import { router } from '@/AppBookingFunnel/router'

function isIframe() {
  return window.location !== window.parent.location
}

// Trick so typescript knows window.delphiDatalayer can exist
interface CustomWindow extends Window {
  delphiDatalayer?: unknown[]
}
const customWindow = window as unknown as CustomWindow

const pushToDatalayer = (event: unknown) => {
  if (!customWindow.delphiDatalayer) {
    customWindow.delphiDatalayer = []
  }
  customWindow.delphiDatalayer.push(event)
}

export function useGtm() {
  function virtualPageFunnel(to?: string) {
    let fullUrl: string
    if (to && router) {
      fullUrl = to.startsWith('/') ? to.substring(1) : to
      if (fullUrl == 'package-search') fullUrl = 'select-package'
      if (fullUrl == 'meeting-room-search') fullUrl = 'select-venue'
      if (fullUrl == 'package-configuration') fullUrl = 'configure-event'
      if (fullUrl == 'checkout') fullUrl = 'checkout'
      fullUrl = new URL(fullUrl, location.protocol + '//' + location.host + location.pathname).href
    } else {
      fullUrl =
        decodeURIComponent(location.protocol + '//' + location.host + location.pathname).replace(
          /([a-zA-Z0-9+._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/,
          '',
        ) + (to || '')
    }
    console.debug(`[Gtm]: '${fullUrl}' virtualPage tracked`)
    if (isIframe()) {
      parent.postMessage(
        JSON.stringify({
          src: 'amadeus.com',
          event: 'virtualPage',
          eventData: {
            event_source: 'gaEventDelphiDirect',
          },
          page_name: fullUrl,
        }),
      )
    } else {
      pushToDatalayer({
        event: 'virtualPage',
        eventData: {
          event_source: 'gaEventDelphiDirect',
        },
        page_name: fullUrl,
      })
    }
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  function event(name: string, ecommerce: any) {
    console.debug(`[Gtm]: ${name} tracked`)
    if (isIframe()) {
      parent.postMessage(
        JSON.stringify({
          src: 'amadeus.com',
          ecommerce: null,
        }),
      )
      parent.postMessage(
        JSON.stringify({
          src: 'amadeus.com',
          event: name,
          eventData: {
            event_source: 'gaEventDelphiDirect',
          },
          ecommerce: ecommerce,
        }),
      )
    } else {
      pushToDatalayer({ ecommerce: null })
      pushToDatalayer({
        event: name,
        eventData: {
          event_source: 'gaEventDelphiDirect',
        },
        ecommerce: ecommerce,
      })
    }
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  function eventData(name: string, eventData: any) {
    console.debug(`[Gtm]: ${name} tracked`)
    if (isIframe()) {
      parent.postMessage(
        JSON.stringify({
          src: 'amadeus.com',
          event: name,
          eventData: eventData,
        }),
      )
    } else {
      pushToDatalayer({
        event: name,
        eventData: eventData,
      })
    }
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  function purchase(ecommerce: any) {
    console.debug(`[Gtm]: purchase tracked`)
    if (isIframe()) {
      parent.postMessage(
        JSON.stringify({
          src: 'amadeus.com',
          ecommerce: null,
        }),
      )
      parent.postMessage(
        JSON.stringify({
          src: 'amadeus.com',
          event: 'purchase',
          eventData: {
            event_source: 'gaEventDelphiDirect',
          },
          ecommerce: ecommerce,
        }),
      )
    } else {
      pushToDatalayer({ ecommerce: null })
      pushToDatalayer({
        event: 'purchase',
        eventData: {
          event_source: 'gaEventDelphiDirect',
        },
        ecommerce: ecommerce,
      })
    }
  }

  function formStart(event: string, form_type: string, event_source: string, rfp_type: string) {
    console.debug(`[Gtm]: form start`)
    const eventDataObj = {
      method: 'form',
      form_type: form_type,
      step: 'form_start',
      event_source: event_source,
      rfp_type: rfp_type,
    }
    if (isIframe()) {
      parent.postMessage(
        JSON.stringify({
          src: 'amadeus.com',
          event: event,
          eventData: eventDataObj,
        }),
      )
    } else {
      pushToDatalayer({
        event: event,
        eventData: eventDataObj,
      })
    }
  }

  function formEnd(event: string, form_type: string, event_source: string, step: string) {
    console.debug(`[Gtm]: form end`)
    const eventDataObj = {
      method: 'form',
      form_type: form_type,
      step: step,
      event_source: event_source,
    }
    if (isIframe()) {
      parent.postMessage(
        JSON.stringify({
          src: 'amadeus.com',
          event: event,
          eventData: eventDataObj,
        }),
      )
    } else {
      pushToDatalayer({
        event: event,
        eventData: eventDataObj,
      })
    }
  }

  return {
    virtualPageFunnel,
    purchase,
    formStart,
    formEnd,
    event,
    eventData,
  }
}
